import { create } from "zustand";
import { selectedCompanyId, setSelectedCompanyId } from "../lib/api";

// The admin section's company context (global admins switch it; company admins
// are pinned to their own). Backed by localStorage so api() can send the
// x-company-id header — the setter writes localStorage FIRST because refetches
// triggered by the state change read the header from there.
interface ActiveCompanyState {
  activeCompanyId: string | null;
  setActiveCompanyId(id: string | null): void;
}

export const useActiveCompany = create<ActiveCompanyState>((set) => ({
  activeCompanyId: selectedCompanyId(),
  setActiveCompanyId: (id) => {
    setSelectedCompanyId(id);
    set({ activeCompanyId: id });
  },
}));
